import { render } from "./InformationPopup.vue?vue&type=template&id=021e817d"
import script from "./InformationPopup.vue?vue&type=script&lang=js"
export * from "./InformationPopup.vue?vue&type=script&lang=js"

import "./InformationPopup.vue?vue&type=style&index=0&id=021e817d&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__